import React, { useEffect, useState } from 'react';
import Plan from './Plan';
import PlanList from './PlanList';
import { Slider } from '@material-ui/core';
import PlansComparison from './PlansComparison';
import { useSelector, shallowEqual } from 'react-redux';
import { ReactComponent as Logo } from '../../../assets/onboarding-logo.svg';

const PLANS = {
	starter: {
		id: 'starter',
		title: 'Starter',
		billingCycle: 'Monthly',
		maxLimit: 3500,
		desc: 'Growth, 750 monthly orders',
		benifits: [
			'Community Feed',
			'Friends Invitation',
			'Customization (color, name...)',
			'Create all type of posts',
			'User notification on answer',
		],
	},
	pro: {
		id: 'pro',
		title: 'Pro',
		billingCycle: 'Monthly',
		maxLimit: 10000,
		desc: 'Growth, 1000 monthly orders',
		benifits: [
			'Challenge',
			'Schedule Posts',
			'Dashboard',
			'Collect Video Review',
			'Influencer Page',
			'Moderation in Dashboard',
			'Feed in Dashboard',
		],
	},
};
const PLANPRICING = [
	{
		monthlySessions: 100,
		pricing: {
			starter: 15,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 500,
		pricing: {
			starter: 49,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 1000,
		pricing: {
			starter: 79,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 2000,
		pricing: {
			starter: 129,
			pro: 199,
			premium: null,
		},
	},
	{
		monthlySessions: 3500,
		pricing: {
			starter: 199,
			pro: 299,
			premium: null,
		},
	},
	{
		monthlySessions: 5000,
		pricing: {
			starter: null,
			pro: 399,
			premium: null,
		},
	},
	{
		monthlySessions: 10000,
		pricing: {
			starter: null,
			pro: 499,
			premium: null,
		},
	},
	{
		monthlySessions: 11000,
		pricing: {
			starter: null,
			pro: null,
			premium: 'CONTACTUS',
		},
	},
];
const marks = [
	{
		value: 0,
		pricing: {
			starter: 79,
		},
		label: '30K',
		monthlySessions: 900,
	},
	{
		value: 25,
		pricing: {
			starter: 99,
			pro: 199,
		},
		label: '60K',
		monthlySessions: 1800,
	},
	{
		value: 50,
		pricing: {
			pro: 299,
		},
		label: '100K',
		monthlySessions: 3000,
	},
	{
		value: 75,
		pricing: {
			pro: 399,
		},
		label: '200K',
		monthlySessions: 6000,
	},
	{
		value: 100,
		pricing: {
			pro: 499,
		},
		label: '300K',
		monthlySessions: 9000,
	},
];

const Overview = () => {
	const [pricePlan, setPricePlan] = useState(PLANPRICING[0]); //selected plan
	const [sliderVal, setSliderVal] = useState(0);
	const [selected, setSelected] = useState(PLANS.starter.id); //id of selected(starter,pro,premium)

	const merchant = useSelector(state => state.merchants.merchants, shallowEqual)[0];
	const changePlanSlider = (event, newValue) => {
		if (sliderVal !== newValue) {
			setSliderVal(newValue)
		}
	};

	useEffect(() => {
		let plan = marks.find(e => e.value === sliderVal);
		if (plan) {
			setPricePlan(plan);
		}
	}, [sliderVal]);

	useEffect(() => {
		for (let key of Object.keys(pricePlan?.pricing || {})) {
			if (pricePlan.pricing[key]) {
				setSelected(PLANS[key].id);
				break;
			}
		}
	}, [pricePlan]);

	return (
		<div style={{ display: 'flex' }}>
			<div className='overview-side' style={{ width: '89px', backgroundColor: '#1e1e2d' }} />
			<div className='overview-wrapper public'>
				<Logo
					className="my-10"
					height="25" />
				<div>
					<h2>Price Plan
					</h2>
					<div className='slider-wrapper'>
						<span className='fs-6 fw-bold mb-5 d-block'>
							Estimated Monthly Traffic:
						</span>
						<Slider
							value={sliderVal}
							onChange={changePlanSlider}
							step={null}
							valueLabelDisplay="off"
							marks={marks}
							style={{ maxWidth: '1000px' }}
						/>
					</div>
					<PlanList
						pricePlan={pricePlan}
						PLANS={PLANS}
						selected={selected}
						setSelected={setSelected}
						setSliderVal={setSliderVal}
					/>
				</div>
				<Plan selected={selected} pricePlan={pricePlan} PLANPRICING={PLANPRICING} PLANS={PLANS} />
				<PlansComparison selected={selected} isShopify={merchant?.shopify} />
			</div>
		</div>
	);
};
export default Overview;
